export interface ParsedTerminalStatusTitle {
  headline: string
  detail: string | null
  /** Named entity when present (set name), otherwise the job type. */
  primary: string
  /** Trailing status suffix stripped from the raw title, e.g. "Complete" or "Failed". */
  statusLabel: string | null
}

/** Split a terminal card title like `Opportunity Set — "Set 1" — Complete`. */
export function parseTerminalStatusTitle(title: string): ParsedTerminalStatusTitle {
  const statusMatch = title.match(/ — (Complete|Failed)$/)
  const statusLabel = statusMatch?.[1] ?? null
  const withoutStatus = statusMatch ? title.slice(0, -statusMatch[0].length) : title

  const dashIdx = withoutStatus.indexOf(" — ")
  if (dashIdx === -1) {
    return { headline: withoutStatus, detail: null, primary: withoutStatus, statusLabel }
  }

  const headline = withoutStatus.slice(0, dashIdx)
  let detail = withoutStatus.slice(dashIdx + 3).trim()
  const quoted = detail.match(/^"(.+)"$/)
  if (quoted) detail = quoted[1]
  const resolvedDetail = detail || null

  return {
    headline,
    detail: resolvedDetail,
    primary: resolvedDetail ?? headline,
    statusLabel,
  }
}
